<template>
  <section>
    <div class="floats">
      <div id="jobsModal" class="modal">
        <div class="modalContent">
          <div class="modalHeading">
            <span class="close" @click="closeModal">&times;</span>
            <div v-if="formUsedFor != 'tenders'"
              style="display: flex;flex-direction: row;align-content: flex-start;justify-content: flex-end;align-items: center;font-size: 14px; justify-content: flex-end; gap: 8px;">
              {{ $t('Change Language') }}:
              <span style="display:inline-block; margin: 16px 0;">
                <button class=""
                  style="position:relative;min-width: 80px; border-radius: 2px;border: none;font-weight: bold; padding: 5px;"
                  v-if="$i18n.locale == 'hi'" type="button" value="null" @click="changeLanguage('en')">{{ "English"
                  }}</button>
                <button class="" v-else type='button'
                  style="position:relative;min-width: 80px; border-radius: 2px;border: none;font-weight: bold; padding: 5px;" value="null"
                  @click="changeLanguage('hi')">{{ "हिंदी" }}</button>
              </span>
            </div>
          </div>
          <div v-if="showForm">
          <FindWorksForm :scope="formUsedFor" :form-used-for="formUsedFor" skill="" pincode=""></FindWorksForm>  
          </div>   
        </div>
      </div>
      
      <!-- Show only Book a Demo button for AI Project Monitoring page -->
      <div v-if="shouldShowDemoAndFaqButton" class="floats">
        <div class="requestDemoFloats" @click="bookDemoGoogleForm">
          <button class="constraButtons">
            Book a Demo
          </button>
        </div>
        <div class="requestDemoFloats" @click="navigateToFaq">
          <button class="constraButtons">
            FAQ
          </button>
        </div>
      </div>

      <!-- Show regular floating buttons for other pages -->
      <template v-else>
        <div id="findTenders" class="requestDemoFloats" @click="findTenders('tenders')">
           <button>
             {{ $filters.msg('FIND_WORK_ON_THEKA') }} 
           </button>
        </div>
        <div id="myBtn" class="requestDemoFloats" @click="openModal('jobs')">
          <button>
            {{ $filters.msg("FIND_WORKS_ON_DEHADI")}}
          </button>
        </div>
        <div id="bestQuotesBtn" class="requestDemoFloats" @click="openModal('contractors')">
            <button>
              Get Best Quotes
            </button>
        </div>
        <div class="registerFloats requestDemoFloats" @click="sendInformationToGoogleAnalitics('website_whatsapp_register_button')">
          <button>
            <a :href="register.url" target="_blank">
              <img src="../assets/img/whatsappicon.png" alt="WhatsApp Register" />Register
            </a>
          </button>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { register } from '@/assets/db/static-data';
import FindWorksForm from "@/components/FindWorksForm.vue"
import { GoogleAdsConversions } from '@/assets/db/config'

export default {
  name: 'BandhooFloats',
  data() {
    return {
      register,
      showForm: false,
      formUsedFor: '',
      demoRoutes: new Set([
        '/solutions/ai_project_monitoring',
        '/solutions/constra_survey', 
        '/solutions/constra_faq'
      ])
    }
  },
  computed: {
    shouldShowDemoAndFaqButton() {
      return this.demoRoutes.has(this.$route.path);
    }
  },
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language;
    },
    findTenders(){
      if(this.$route.path == "/findtenders"){
         this.formUsedFor = "tenders";
         this.showForm = true
         $("jobsModal").style.display = "block";
      }else{
        window.open('/findtenders', '_blank');
      }
    },
    openModal(formUsedFor) {
      if(formUsedFor == 'contractors') {
        this.$i18n.locale = 'en'; //default english for contractors
        if(window.location.pathname == '/findcontractors'){
          $("jobsModal").style.display = "block";
          this.showForm = true
          this.formUsedFor = formUsedFor;
        } else {
          window.open('/findcontractors', '_blank');
        }
        this.sendInformationToGoogleAnalitics('landingpage_bestquote_float')
      } else {
        $("jobsModal").style.display = "block";
        this.showForm = true
        this.formUsedFor = formUsedFor;
        this.sendInformationToGoogleAnalitics('website_' + formUsedFor + "_Float")
      }
    },
    closeModal() {
      this.showForm = false
      $("jobsModal").style.display = "none";
    },
    sendInformationToGoogleAnalitics(information) {
      console.log("Sending information to google analytics...  " + information);
      this.$gtag.event(information);
      console.log("Information sent to google analytics...");
      
      // WhatsappClickNew conversion
      if (information === 'website_whatsapp_register_button') {
        this.$gtag.event('conversion', GoogleAdsConversions.WEBSITE_WHATSAPP);
      }
    },
    
    bookDemoGoogleForm() {
      const demoUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSflVgPRO-tTo3TJxSP02LrthiweDPf3xzgaILMCVy3gmo43vA/viewform?usp=sharing&ouid=116874190052872731313';
      window.open(demoUrl, '_blank');
    },
    
    navigateToFaq() {
      this.$router.push('/solutions/constra_faq');
    }
  },
  mounted: function () {
    this.$i18n.locale = "hi"
    let speech;
    this.$nextTick(()=>{
      if (typeof window.speechRecognizer === 'function') {
        speech = new window.speechRecognizer($("websitepincode"), 'start_img', "websitepincode.");
      }
    });
  },
  components: {
    FindWorksForm
}
}
</script>
<style scoped>
.modal {
  display: none;
  position: fixed;
  z-index: 1;
  margin-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modalHeading {
  width: 100%;
  position: relative;
}

.modalContent {
  background-color: #1e1e1e;
  color: rgb(255, 255, 255);
  margin: auto;
  padding: 16px 40px;
  border-radius: 8px;
  width: 60%;
  max-width: 360px;
  /* display: flex;
  justify-content: space-between; */
}

::placeholder {
  color: rgba(255, 255, 255, 0.468);
}

.modalContent>h2 {
  margin: 16px 0;
}

.modalFindWorks>button {
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #25d366;
  color: white;
}

.close {
  color: #ffffff;
  float: right;
  font-size: 36px;
  font-weight: 500;
  z-index: 10;
  position: absolute;
  right: -30px;
  top: -24px;
}

.close:hover,
.close:focus {
  color: #6dc911;
  text-decoration: none;
  cursor: pointer;
}

.floats {
  position: fixed;
  bottom: 50px;
  right: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  z-index: 101;
}

.registerFloats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
}

.registerFloats>button {
  border-radius: 3px;
}

.registerFloats a,
.requestDemoFloats button {
  color: var(--bb-navy);
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 3px;
  font-weight: 600;
}

.requestDemoFloats button {
  padding: 8px 12px;
}

.registerFloats button,
.requestDemoFloats button {
  background-color: var(--bb-lime);
  color: var(--bb-navy);
}

.requestDemoFloats>a {
  color: var(--bb-navy);
}

.registerFloats>button>a>img {
  height: 20px;
}

.book-demo-float button {
  padding: 12px;
}

.constraButtons {
  font-size: 18px;
}

/* media queries starts */

/* mobile */
@media screen and (max-width: 550px) {

  .userInfo,
  .modalHeading {
    width: 100%;
  }

  .formImg {
    display: none;
  }

  .modalContent {
    width: 90%;
    flex-direction: column;
    gap: 40px;
  }

}

@media screen and (max-width: 730px) and (min-width:550px) {

  .userInfo,
  .modalHeading {
    width: 100%;
  }

  .formImg {
    display: none;
  }

  .modalContent {
    width: 80%;
    flex-direction: column;
    gap: 40px;
  }

}

/* tab */

@media screen and (min-width: 730px) and (max-width:980px) {
  .modalContent {
    width: 70%;
  }
}
</style>